import { render, staticRenderFns } from "./NavigationItemLink.vue?vue&type=template&id=34bdde42"
import script from "./NavigationItemLink.vue?vue&type=script&lang=js"
export * from "./NavigationItemLink.vue?vue&type=script&lang=js"
import style0 from "./NavigationItemLink.vue?vue&type=style&index=0&id=34bdde42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports